import { RootState } from 'Data/Redux';
import { actions } from 'Data/ReduxViewModels/Authentication';
import { hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

const LogOut: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isEntraInitialised = useSelector((state: RootState) => state.authentication.entra.isInitialised);
  const isEntraEnabled = useSelector(pipe((state) => state.authentication.authSettings?.isEntraEnabled));

  useEffect(() => {
    if (!hasValue(isEntraEnabled)) return;
    if (isEntraEnabled && !isEntraInitialised) return;

    if (isEntraEnabled) dispatch(actions.postEntraLogout());
    navigate('/qp');
  }, [isEntraEnabled, isEntraInitialised, dispatch, navigate]);

  return null;
};
export default LogOut;
